import { isDraftSaveAction } from '../../../Draft'
import { FormModalConfirmation } from '../../../Form'
import { RentalPortalListingDraftCloseActionSelectModal } from '../../RentalPortalListingDraft'
import { useRentalPortalListingDraft } from '../useRentalPortalListingDraft'

export function useRentalPortalListingFormCloseConfirmation({
  hasSavedRecord,
  onClose,
  onSubmitConfirm,
}) {
  const { draftId, setDraft } = useRentalPortalListingDraft()

  function handleSubmitConfirm(values, files, action) {
    if (!hasSavedRecord) {
      setDraft(isDraftSaveAction(action) ? values : null, 0)
    }

    onSubmitConfirm?.(values, files, action)
    onClose()
  }

  return {
    Confirmation:
      draftId && !hasSavedRecord
        ? RentalPortalListingDraftCloseActionSelectModal
        : FormModalConfirmation,
    handleSubmitConfirm,
  }
}
